var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full"},[_c('canvas',{ref:"canvasEl",staticClass:"h-full w-full"})])
}
var staticRenderFns = []

export { render, staticRenderFns }